module.exports = __webpack_public_path__ + "img/16.cc2976e1.png";